import AsyncTable from "components/AsyncTable"
import { Badge, Divider, Flex, Input, InputGroup, InputLeftAddon, Text, useDisclosure } from "@chakra-ui/react"
import StatusIndicator from "components/StatusIndicator"
import { riskColor, riskLabel } from "enums/labelRisks"
import { useLazyPaginateLives, usePaginateLives } from "hooks/useLives"
import { useSelector } from "react-redux"
import { findLastMetricInAssessmentsByTag } from "functions/lives/metrics"
import { State } from "state/reducers"
import { CalendarDots, Eye, LinkIcon, WhatsappLogo } from "@phosphor-icons/react"
import dateFormat, { splitDateFormat } from "functions/dateFormat"
import { useState } from "react"
import TableFilterBox from "components/TableFilterBox"
import { FormProvider, useForm } from "react-hook-form"
import InputMask from "react-input-mask";
import { format } from "date-fns"
import { usePaginateGlucose } from "hooks/useGlucoseRegister"
import ViewMonitoring from "./ViewMonitoring"
import { Roles } from "enums/roles"
import SendLink from "./SendLink"

const GlucoseTable = () => {
    const header = [
        {
            label: 'Nome',
            acessor: 'name',
        },
        {
            label: 'Nº Carteirinha',
            acessor: 'registration_number',
        },
        {
            label: 'CPF',
            acessor: 'cpf',
        },
        {
            label: 'Telefone',
            acessor: 'phone',
        },
        {
            label: 'Data de cadastro',
            acessor: 'created_at',
            custom: (value: any) => <Text>{dateFormat(value)}</Text>
        },
    ]

    const methods = useForm<any>({
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        defaultValues: {
            "start_date": "",
            "end_date": "",
        }
    });

    const { register, getValues } = methods;

    const { loading, refetch } = usePaginateGlucose();
    const [reloading, setReloading] = useState<boolean>(false);

    const { paginatorInfo, data } = useSelector(({ glucose }: State) => glucose)

    const { isOpen, onOpen, onClose } = useDisclosure()
    const { isOpen: sendLinkIsOpen, onOpen: onOpenLink, onClose: onCloseLink } = useDisclosure()
    const [optionID, setOptionID] = useState<string>("");

    const handleFilter = async () => {
        const filters = getValues();
        
        if(filters.start_date != '')
            filters.start_date = splitDateFormat(filters.start_date);

        if(filters.end_date != '')
            filters.end_date = splitDateFormat(filters.end_date);

        setReloading(true);
        await refetch({
            page: 1,
            filters: JSON.stringify(filters)
        })
        setReloading(false);
    }

    const handleResetFilter = async () => {
        setReloading(true);
        await refetch({
            page: 1,
            filters: ""
        })
        setReloading(false);
    }

    const onPaginationChange = async (page: number, per_page: number, search: string = '') => {
        setReloading(true);
        await refetch({
            page,
            first: per_page,
            search
        })
        setReloading(false);
    }

    const filterFields = [
        {
            name: "start_date",
            label: "Início Data de criação",
            colSpan: 1,
            component: 
            <InputGroup>
                <InputLeftAddon><CalendarDots size={22} /></InputLeftAddon>
                <Input
                    {...register('start_date')}
                    as={InputMask}
                    mask="99/99/9999"
                    placeholder='__/__/____'
                    borderRadius="8px"
                    fontSize="md"
                />
            </InputGroup>
        },
        {
            name: "end_Date",
            label: "Final Data de criação",
            colSpan: 1,
            component: 
            <InputGroup>
                <InputLeftAddon><CalendarDots size={22} /></InputLeftAddon>
                <Input
                    {...register('end_date')}
                    as={InputMask}
                    mask="99/99/9999"
                    placeholder='__/__/____'
                    borderRadius="8px"
                    fontSize="md"
                />
            </InputGroup>
        },
    ]

    const onOpenModal = (id: string) => {
        setOptionID(id)
        onOpen();
    }

    const onSendLink = (id: string) => {
        setOptionID(id)
        onOpenLink();
    }

    const customActions = [
        {
            label: "Enviar Link",
            callback: (id: string) => onSendLink(id),
            icon: <LinkIcon weight="bold" />,
            color: "green",
            roles: [Roles.ADMINISTRADOR, Roles.OPERADOR, Roles.SUPER_ADMIN]
        },
        {
            label: "Visualizar",
            callback: (id: string) => onOpenModal(id),
            icon: <Eye weight="bold" />,
            color: "green",
            roles: [Roles.ADMINISTRADOR, Roles.OPERADOR, Roles.SUPER_ADMIN]
        }
    ]

    return (
        <>
            <FormProvider {...methods}>
                <Flex direction="column" w="full">
                    {/* <TableFilterBox fields={filterFields} handleClear={handleResetFilter}  handleFilter={handleFilter} /> */}
                    <Divider py={4} />
                    <AsyncTable 
                        isLoading={loading || reloading} 
                        header={header} 
                        per_page={paginatorInfo.perPage}
                        current_page={paginatorInfo.currentPage}
                        total={paginatorInfo.total}
                        data={data}
                        onPaginationChange={onPaginationChange}
                        customActions={customActions}
                        noView
                        noDelete
                        noEdit
                    />
                    {
                        isOpen && <ViewMonitoring isOpen={isOpen} onClose={onClose} id={optionID} />
                    }
                    {
                        sendLinkIsOpen && <SendLink isOpen={sendLinkIsOpen} onClose={onCloseLink} id={optionID} />
                    }
                </Flex>
            </FormProvider>
        </>
    )
}

export default GlucoseTable